import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

interface CallableSuccess<T> {
  success: boolean;
  data: T;
}

interface SetCompanyEmailImportEnabledParams {
  company_id: string;
  enabled: boolean;
  note?: string;
}

/**
 * 企業単位のメール取り込み機能の有効/無効を切り替える（運営スタッフ専用）。
 */
export const setCompanyEmailImportEnabled = async (
  params: SetCompanyEmailImportEnabledParams,
): Promise<{ before: boolean; after: boolean }> => {
  const callable = httpsCallable<
    SetCompanyEmailImportEnabledParams,
    CallableSuccess<{ before: boolean; after: boolean }>
  >(functions, 'setCompanyEmailImportEnabled');
  const result = await callable(params);
  return result.data.data;
};
